/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 0C9.1005 0 6.75 2.3505 6.75 5.25V6H4.3094C3.1842 6 2.232 6.8312 2.08 7.946L.4713 19.7433C.1643 21.9949 1.9144 24 4.1869 24H12a.75.75 0 0 0 0-1.5H4.1869c-1.3635 0-2.4136-1.203-2.2294-2.554L3.5662 8.1487A.75.75 0 0 1 4.3094 7.5H6.75v.75a.75.75 0 0 0 1.5 0V7.5h7.5v.75a.75.75 0 0 0 1.5 0V7.5h2.4407a.75.75 0 0 1 .7431.6487l.3856 2.8276a.75.75 0 1 0 1.4862-.2026L21.92 7.946C21.768 6.8312 20.8158 6 19.6907 6H17.25v-.75C17.25 2.3505 14.8995 0 12 0Zm3.75 6v-.75c0-2.071-1.6789-3.75-3.75-3.75-2.071 0-3.75 1.679-3.75 3.75V6h7.5Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18 12a.75.75 0 0 1 .75.75v4.5h4.5a.75.75 0 0 1 0 1.5h-4.5v4.5a.75.75 0 0 1-1.5 0v-4.5h-4.5a.75.75 0 0 1 0-1.5h4.5v-4.5A.75.75 0 0 1 18 12Z"
    />
  </React.Fragment>,
  'AddMarketPlace'
);
